const initialState = {
  chats: [],
  contacts: [],
  userProfile: {},
  selectedUser: {},
  selectedDocument: {},
  selectedDocumentService: {}
}

const chatReducer = (state = initialState, action) => {
  console.log("Estamos aqui")
  switch (action.type) {
    case 'GET_USER_PROFILE':
      return { ...state, userProfile: action.userProfile }
    case 'GET_CHAT_CONTACTS':
      return { ...state, chats: action.data.chatsContacts, contacts: action.data.contacts }
    case 'SELECT_CHAT':
      return { ...state, selectedUser: action.data }
    case 'SELECT_DOCUMENT':
      return { ...state, selectedDocument: action.data }
    case 'SET_DOCUMENT_SERVICE':
      console.log("Alo, esto es Set_Document")
      return { ...state, selectedUser: action.data }
    case 'GET_DOCUMENT_SERVICE':
      return state
    case 'SEND_MSG':
      // ** Add new msg to chat
      const newMsg = action.data.response.chat
      return { ...state, selectedUser: { ...state.selectedUser, chat: newMsg } }
    default:
      return state
  }
}

export const getDocData = (state) => state.initialState.selectedDocumentService

export default chatReducer
